'use client';

import React from 'react';
import Script from 'next/script';

interface ContactFormProps {
  className?: string;
}

const ContactForm: React.FC<ContactFormProps> = ({ className = '' }) => {
  return (
    <>
      {/* Load Jotform Embed Handler Script */}
      <Script
        src="https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js"
        strategy="afterInteractive"
      />

      {/* Jotform Embed Handler Initialization */}
      <Script
        id="jotform-embed-handler"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            if (typeof window !== 'undefined' && window.jotformEmbedHandler) {
              window.jotformEmbedHandler("iframe[id='JotFormIFrame-231896189018164']", "https://form.jotform.com/");
            }
          `,
        }}
      />

      <section className={`py-16 md:py-20 bg-white ${className}`}>
        <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-headline font-bold text-brand-plum mb-4">
              Client Intake Form
            </h2>
            <p className="text-lg text-brand-plum/70 font-body max-w-2xl mx-auto">
              Fill out our intake form below. We'll review your information and get back to you within 24 hours.
            </p>
          </div>

          {/* Jotform Iframe Embed */}
          <div className="w-full">
            <iframe
              id="JotFormIFrame-231896189018164"
              title="New Client Intake"
              onLoad={() => window.parent.scrollTo(0, 0)}
              allowTransparency={true}
              allow="geolocation; microphone; camera; fullscreen; payment"
              src="https://form.jotform.com/231896189018164"
              frameBorder="0"
              style={{
                minWidth: '100%',
                maxWidth: '100%',
                height: '1500px',
                border: 'none',
                overflowY: 'auto',
              }}
              scrolling="yes"
            />
          </div>

          {/* Trust Signal */}
          <div className="mt-8 text-center">
            <p className="text-sm text-brand-plum/60 font-body">
              Your information is secure and confidential. We respect your privacy and will never share your details.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;